const roles = {
    isBasic: ['*'],
    isAdmin: ['Admins Ops'],
    isCoder: ['Coders Ops'],
    isCV: ['CV Ops'],
    isVideoClient : ['Video-Clients','Admins Ops'],
};

export default roles;